import React from 'react';

const ButtonBox = ({ children }) => {
    return (
        <div className='ButtonBox'>
       { children }
        </div>
    );
}

export default ButtonBox;